import type { ColumnDefProps } from '@components/shared/Table/types'
import type { WeeklyClBreakdownItemProps } from '../context/types'
import { numberMask } from '@utils/masks/cpfMask'

interface ParseOtherServicesProps {
  data: WeeklyClBreakdownItemProps[]
}

export const parseWeeklyBreakdownGrid = ({ data }: ParseOtherServicesProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'serviceGrouping',
      columnName: 'Agrupamento',
      value: item.serviceGrouping || '',
      minWidth: '10rem',
      sortable: true,
      sortKey: 'servicegrouping',
      headerAlign: 'center',
      bodyAlign: 'left'
    },
    {
      id: 'salesItemName',
      columnName: 'Descrição Serviço',
      value: item.salesItemName ? `${item.salesItemCode} - (${item.salesItemName})` : '',
      sortable: true,
      sortKey: 'salesitemname',
      headerAlign: 'center',
      bodyAlign: 'left'
    },
    {
      id: 'billingTaxPercentage',
      columnName: 'Imposto (%)',
      value: item.billingTaxPercentage ? `${item.billingTaxPercentage.toFixed(2)}%`.replace('.', ',') : '',
      align: 'center',
      minWidth: '9rem',
      sortable: false
    },
    {
      id: 'previousBilledQuantity',
      columnName: 'Qtd. Total',
      value: item.previousBilledQuantity ? numberMask(String(item.previousBilledQuantity)) : '',
      align: 'center',
      // 9rem para o rótulo "Total Quantidades" da linha de total caber sem truncar.
      minWidth: '9rem',
      sortable: true,
      sortKey: 'quantity',
      headerAlign: 'center'
    },
    {
      id: 'totalGrossAmount',
      columnName: 'Total Bruto (R$)',
      value: item.totalGrossAmount || 0,
      currency: true,
      align: 'center',
      sortable: true,
      sortKey: 'grossamount',
      minWidth: '12rem',
      headerAlign: 'center',
      bodyAlign: 'right'
    },
    {
      id: 'totalNetAmount',
      columnName: 'Total Líquido (R$)',
      value: item.totalNetAmount || 0,
      currency: true,
      align: 'center',
      sortable: true,
      sortKey: 'netamount',
      minWidth: '12rem',
      headerAlign: 'center',
      bodyAlign: 'right'
    }
  ])

  return parsedData
}
